<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="TocSb2" id="ack"><a id="page_v"></a><a href="#/xhtml/acknowledgments#ack">Acknowledgments</a></p>
<p class="Toc2" id="abb"><a href="#/xhtml/abbreviations#abb">Abbreviations and Notes on Citations</a></p>
<p class="Toc2" id="nt"><a href="#/xhtml/note#nt">A Note on Spelling and Punctuation</a></p>
<p class="TocSb1" id="ch001"><a href="#/xhtml/chapter001#ch001">1.<span class="space">“Different Kings and Different Laws”</span></a></p>
<p class="Toc1" id="s01"><a href="#/xhtml/chapter001#ch001">Christian Liberty and the Conflict of Loyalties since the Reformation</a></p>
<p class="TocSb1" id="ch002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.<span class="space">Freedom for the Neighbor</span></span></p>
<p class="Toc1" id="s02"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">Christian Liberty and the Demand for Edification</span></p>
<p class="TocSb1" id="ch003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space">“Exact Precise Severity”</span></span></p>
<p class="Toc1" id="s03"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">The Puritan Challenge to Prince and Conscience</span></p>
<p class="TocSb1" id="ch004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space">Richard Hooker and the Freedom of a “Politic Society”</span></span></p>
<p class="Toc1" id="s04"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">Between Legalism and Libertinism</span></p>
<p class="TocSb1" id="ch005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space">Harmonized Loyalties</span></span></p>
<p class="Toc1" id="s05"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">Conscience, Reason, and Corporate Moral Agency</span></p>
<p class="TocSb1" id="ch006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space">The Soul of a Christian Commonwealth</span></span></p>
<p class="Toc1" id="s06"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">Politics in Submission to the Word</span></p>
<p class="TocSb1" id="ch007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space">“The Truth Will Set You Free”</span></span></p>
<p class="Toc1" id="s07"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">The Peril and Promise of Christian Liberty</span></p>
<p class="Toc3" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toc2" id="ind"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?96ec078e